    angular.module('assets')
        .component('assetProjectStorage', {
            bindings: {
                assetId: '<',
                totalQuantity: '<'
            },
            templateUrl: 'app/asset/storage/asset-storage.html',
            controller: function (Asset, ProjectService){
                this.ProjectService = ProjectService;

                this.$onInit = () => {
                    this.filters = {};
                    this.reloadList();
                }

                this.clear = () => this.$onInit()
                this.reloadList = () => {
                    return Asset.storage({id: this.assetId}).$promise.then(response => this.storageList = response);
                };
            }
        })
